import { lazy } from "react";

export const Home = lazy(() =>
  import("./home").then((module) => ({
    default: module.HomePage,
  })),
);

//about
export const About = lazy(() =>
  import("./about").then((module) => ({
    default: module.About,
  })),
);

//contact us
export const Contact = lazy(() =>
  import("./contactUs").then((module) => ({
    default: module.ContactUs,
  })),
);